import apiWrapper from '../../../common/api/api-wrapper';
import { IAPIErrorContent } from '../../../common/api/type-def';

import {
	IGetReportRequestParams,
	IFavoriteParams,
	IGetReportsData,
	IReportConfigData,
} from './type-def';

const POWER_BI_SERVICE = process.env.REACT_APP_POWER_BI_SERVICE;

export const getReports = async (params: IGetReportRequestParams) => {
	const {
		pageNumber,
		pageSize,
		sortKey,
		sortDirection,
		reportType,
		dashboardType,
	} = params;
	const key = sortKey || '';
	const direction = sortDirection || '';
	const sort = sortKey !== '' ? `${key},${direction}` : '';
	const queryParams = `?reportType=${reportType}&dashboardType=${dashboardType}&page=${pageNumber}&size=${pageSize}&sort=${sort}`;
	const resp = await apiWrapper.get<IGetReportsData, IAPIErrorContent>(
		`${POWER_BI_SERVICE}/search${queryParams}`,
	);
	return resp;
};

export const favoriteReport = async (params: IFavoriteParams) => {
	const resp = await apiWrapper.post<string, IAPIErrorContent>(
		`${POWER_BI_SERVICE}/favourite`,
		params,
	);
	return resp;
};

export const getReportDetail = async (reportId: string) => {
	const resp = await apiWrapper.get<IReportConfigData, IAPIErrorContent>(
		`${POWER_BI_SERVICE}/${reportId}`,
	);

	return resp;
};
